/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Unlimited_SubInputs */

const en_dialog_premium_unlimited_sub = /** @type {(inputs: Dialog_Premium_Unlimited_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free is limited to 3 uploads a week`)
};

const es_dialog_premium_unlimited_sub = /** @type {(inputs: Dialog_Premium_Unlimited_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis limitado a 3 subidas por semana`)
};

/**
* | output |
* | --- |
* | "Free is limited to 3 uploads a week" |
*
* @param {Dialog_Premium_Unlimited_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_unlimited_sub = /** @type {((inputs?: Dialog_Premium_Unlimited_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Unlimited_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_unlimited_sub(inputs)
	return en_dialog_premium_unlimited_sub(inputs)
});